// extracted by mini-css-extract-plugin
export const form = "form-module--form--1ahMB";
export const dark = "form-module--dark--4X957";
export const button = "form-module--button--1PwUY";